
        var i18n = require('cadenza/utils/i18n/i18n');
        module.exports = (function () {
          var messages = {"en":{"cancel":"Cancel","close":"Close","fullscreen":"Fullscreen","exitFullscreen":"Exit fullscreen mode","ok":"OK"},"de":{"cancel":"Abbrechen","close":"Schließen","fullscreen":"Vollbild","exitFullscreen":"Vollbildmodus verlassen","ok":"OK"}};
          return function () {
            return i18n.loaderI18n.apply(messages[window.Disy.language], arguments);
          };
        })();